import { getDefaultShopConfig } from './default';
import * as custom from '../filters/marketplace-custom-config';
import { getBrandDirectFilterConfig } from '../filters/brandDirect';
import { getConditionsFilterConfig } from '../filters/condition';
import { getSizeFilterConfig } from '../filters/size';

const thebeaufortbonnetcompanySizes = [
  '2T',
  '3T',
  '4T',
  '5T',
  '0/6m',
  '6/12m',
  '12/18m',
  '18/24m',
  '5',
  '6',
  '7',
  '8',
  '9',
  '10',
  '11',
  '12',
  '13',
  '14',
  'XXS',
  'XS',
  'S',
  'M',
  'L',
  'XL',
  'XXL',
];

export const thebeaufortbonnetcompanyShopConfig = {
  ...getDefaultShopConfig(),
  filters: [
    ...custom.filters,
    getConditionsFilterConfig(),
    getBrandDirectFilterConfig(),
    getSizeFilterConfig({ sizes: thebeaufortbonnetcompanySizes }),
  ],
};
